@if (field) {
  <div class="modal fade" id="edit-stakeholder-details-modal" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit</h5>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body" [hidden]="field !== 'email'">
          <form #editEmailForm="ngForm">
            <div class="form-group">
              <label>Email</label>
              <input class="form-control" type="email" [ngClass]="setClassInvalidTpl(email)" #email="ngModel"
                name="email" [(ngModel)]="politician.email" [pattern]="emailRegexp" placeholder="mario.rossi@example.com">
            </div>
          </form>
        </div>

        <div class="modal-body" [hidden]="field !== 'phone'">
          <form #editPhoneForm="ngForm">
            <div class="form-group">
              <label>Phone</label>
              <input class="form-control" type="text" name="phone" [(ngModel)]="politician.phone" placeholder="+39 06 12345678">
            </div>
          </form>
        </div>

        <div class="modal-body" [hidden]="field !== 'english'">
          <form #editEnglishForm="ngForm">
            <div class="form-group">
              <label>English speaking</label>
              <select class="form-control" name="english" [(ngModel)]="politician.english">
                <option value="">Unknown</option>
                <option [value]="true">Yes</option>
                <option [value]="false">No</option>
              </select>
            </div>
          </form>
        </div>

        <div class="modal-body" [hidden]="field !== '_organization'">
          <form #editOrganizationForm="ngForm">
            <div class="form-group">
              <label>Organization</label>
              <select class="form-control" name="_organization" [(ngModel)]="politicianOrganizationId._id">
                <option value="">None</option>
                @for (org of orgs; track org._id) {
                  <option [value]="org._id">{{org.name}}</option>
                }
              </select>
            </div>
          </form>
        </div>

        <div class="modal-body" [hidden]="field !== 'notes'">
          <form #editNotesForm="ngForm">
            <div class="form-group">
              <label>Notes</label>
              <textarea class="form-control" name="notes" [(ngModel)]="politician.notes" rows="5" placeholder="Notes"></textarea>
            </div>
          </form>
        </div>

        <div class="modal-body" [hidden]="field !== 'topics'">
          <form #editTopicsForm="ngForm">
            <div class="form-group">
              <label>Topics</label>
              <div class="d-flex flex-wrap gap-2 mt-1">
                @for (cluster of clusters; track cluster) {
                  <button type="button" class="btn btn-sm"
                    [ngClass]="{ 'btn-primary': politician.topics?.includes(cluster), 'btn-outline-secondary': !politician.topics?.includes(cluster) }"
                    (click)="selectCluster(cluster)">
                    {{cluster}}
                  </button>
                }
              </div>
            </div>
          </form>
        </div>

        <div class="modal-body" [hidden]="field !== '_users'">
          <form #editUsersForm="ngForm">
            <div class="form-group">
              <label>Responsible team members</label>
              <input type="hidden" name="_users">
              <app-search-input model="user"></app-search-input>
            </div>
          </form>
        </div>

        <div class="modal-body" [hidden]="field !== 'socials'">
          <form #editSocialsForm="ngForm">
            <div class="form-group">
              <label>X (Twitter)</label>
              <input class="form-control" type="text" [ngClass]="setClassInvalidTpl(twitter)" #twitter="ngModel"
                [(ngModel)]="politician.socials.twitter.username" name="twitter"
                [pattern]="usernameRegexp.twitter" placeholder="mario_rossi">
            </div>
            <div class="form-group">
              <label>Instagram</label>
              <input class="form-control" type="text" [ngClass]="setClassInvalidTpl(instagram)" #instagram="ngModel"
                [(ngModel)]="politician.socials.instagram.username" name="instagram"
                [pattern]="usernameRegexp.instagram" placeholder="mario.rossi">
            </div>
            <div class="form-group">
              <label>Facebook</label>
              <input class="form-control" type="text" [ngClass]="setClassInvalidTpl(facebook)" #facebook="ngModel"
                [(ngModel)]="politician.socials.facebook.username" name="facebook"
                [pattern]="usernameRegexp.facebook" placeholder="MarioRossiOfficial">
            </div>
            <div class="form-group">
              <label>LinkedIn</label>
              <input class="form-control" type="text" [ngClass]="setClassInvalidTpl(linkedin)" #linkedin="ngModel"
                [(ngModel)]="politician.socials.linkedin.username" name="linkedin"
                [pattern]="usernameRegexp.linkedin" placeholder="mario-rossi">
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
            [disabled]="(field === 'email' && !editEmailForm.form.valid) || (field === 'socials' && !editSocialsForm.form.valid)"
            (click)="updatePolitician(field)">
            <i class="fa fa-floppy-o"></i> Save
          </button>
        </div>
      </div>
    </div>
  </div>
}
